import {on} from "@/others/common/eventDelegation";
import {toggleImageVisibility} from "@/front/js/components/images/toggleImageVisibility";

on("body", "click", ".open-image-variant", event => {
	const targetEl = event.target.closest(".open-image-variant");
	const productItemEl = targetEl.closest(".product-item");
	const imgsEl = productItemEl.querySelectorAll(".product-variant-image");
	const openVariantId = targetEl.dataset.open;
	const currentVariantImageEl = productItemEl.querySelector("[data-variant='" + openVariantId +"']");

	toggleImageVisibility(imgsEl, currentVariantImageEl);
});
